import { call, put } from 'redux-saga/effects';
import { ACTIONS, APIS } from '../../_config';
import { CallApi } from '../api/callApi';




export function* GetFacilityList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.FACILITY.GET_FACILITY_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* GetFacilityManagerList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.FACILITY.GET_FACILITY_MANAGER_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* getFacilityDetails(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.FACILITY.GET_FACILITY_DETAILS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* SaveFacility(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.FACILITY.SAVE_FACILITY, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* SaveFacilityMaster(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.FACILITY.SAVE_FACILITY_MASTER, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* SaveTeam(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.FACILITY.SAVE_TEAM, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* SaveDepartment(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.ASSETS.INSERT_UPDATE_DEPARTMENT, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* SaveServiceTechMaster(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.FACILITY.SAVE_SERVICE_TECH_MASTER, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* DeleteFacility(action: any): any {
    try {
        const data:any = action.payload;
        const resp = yield call(CallApi.DELETE, APIS.FACILITY.DELETE_FACILITY+'?facilityID='+data?.facilityID, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* DeleteFacilityManager(action: any): any {
    try {
        const data: any = action.payload;
        const resp = yield call(CallApi.DELETE, APIS.FACILITY.DELETE_FACILITY_MANAGER + '?facilityManagerID=' + data?.facilityManagerMasterId, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data?.message || 'Failed to delete facility manager');
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* DeleteServiceTech(action: any): any {
    try {
        const data: any = action.payload;
        const resp = yield call(CallApi.DELETE, APIS.FACILITY.DELETE_SERVICE_TECH + '?serviceTechID=' + data?.serviceTechID, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data?.message || 'Failed to delete service tech');
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetProcessingFacilityList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.FACILITY.GET_PROCESSING_FACILITY_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* getFacilityCode(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.FACILITY.GET_FACILITY_CODE, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetSubFacilityList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.FACILITY.GET_SUB_FACILITY_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* SaveSubFacility(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.FACILITY.SAVE_SUB_FACILITY, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* SaveSubFacilityImage(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.FACILITY.SAVE_SUB_FACILITY_IMAGE, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* SaveFacilityImage(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.FACILITY.SAVE_FACILITY_IMAGE, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* GetSubFacilityTypeList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.FACILITY.GET_SUB_FACILITY_TYPE_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}




export function* Exportcsv(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.FACILITY.EXPORT_TO_CSV, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* Exportpdf(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.FACILITY.EXPORT_TO_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* ExportQRCode(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.FACILITY.EXPORT_QR_CODE, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetFacilityActivity(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.FACILITY.GET_FACILITY_ACTIVITY, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* UpdateFacilityActivityLogStatus(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.FACILITY.UPDATE_FACILITY_ACTIVITY_LOG_STATUS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data, resp.data.message);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* DeleteFacilityActivityLog(action: any): any {
    try {
        const data: any = action.payload;
        const resp = yield call(CallApi.DELETE, APIS.FACILITY.DELETE_FACILITY_ACTIVITY_LOG + '?FacilityActivityLogID=' + data?.FacilityActivityLogID, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data, resp.data.message);
        } else {
            action && action.callbackError && action.callbackError(resp.data?.message || 'Failed to delete facility activity log');
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}




 

 



